import { render, staticRenderFns } from "./SoftSearchVehicle.vue?vue&type=template&id=2b5977b1"
import script from "./SoftSearchVehicle.vue?vue&type=script&lang=js"
export * from "./SoftSearchVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports